export default __webpack_public_path__ + "assets/0ee29ff8ea00082fcb8113a92a876a0c.webp";